var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('div',{staticClass:"container"},[_c('login-sign-up')],1),_c('div',{staticClass:"container"},[_c('info-banners')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('h1',{staticClass:"title_message"},[_vm._v("WELCOME!")])])
}]

export { render, staticRenderFns }